var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-title',{attrs:{"img":_vm.img,"title":"董事长致辞"}}),_c('div',{staticClass:"speech center",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }